import { useInvoiceCentralLayoutContext } from '@/enterprise/components/InvoiceCentral/InvoiceCentralLayout';
import { IneligibleInvoicesView } from '@/enterprise/features/invoiceTables/ineligible';
import useFeature from '@/lib/features';
import { useReporting } from '@/reporting';
import useDataDog from '@/reporting/DataDog';

/**
 * Invoice Central ineligible tab — thin host over the shared SEA locked-invoice view.
 * Filter-bar download (all / filtered SEA CSV) is owned by IneligibleInvoicesView.
 */
const IneligibleInvoices = () => {
  const { addAction } = useDataDog();
  const { trackEnterpriseEvent } = useReporting();
  const [invoiceApiMigrationEnabled] = useFeature('enterprise-ui_invoiceApiMigration');
  const {
    buyer,
    urlParams: { makerOrganizationUuid, currency },
  } = useInvoiceCentralLayoutContext();
  const { takerMarkets } = buyer;

  return (
    <IneligibleInvoicesView
      source={{
        makerOrganizationUuid,
        makerOrganizationName: buyer.makerOrganizationName,
        currency,
        takerMarkets,
      }}
      actions={{
        enableFilterBarDownload: invoiceApiMigrationEnabled,
        onDownloadSubmitted: ({ scope }) => {
          trackEnterpriseEvent('invoice-central::download-invoices::submitted', {
            invoiceType: 'ineligible',
            downloadScope: scope,
            takerMarketIds: takerMarkets.map((tm) => ({
              takerId: tm.takerDivisionId,
              marketId: tm.legacyMarketId,
            })),
          });
        },
        onSearch: () => {
          addAction('invoice-central::invoices-searched', {
            invoiceType: 'ineligible',
            makerOrganizationUuid,
            currency,
          });
        },
        onSort: ({ sortKey, sortDirection }) => {
          addAction('invoice-central::sort::changed', {
            invoiceType: 'ineligible',
            sortKey,
            sortDirection,
            makerOrganizationUuid,
            currency,
          });
        },
        onFiltersChange: ({ filterKeys }) => {
          addAction('invoice-central::filters::changed', {
            invoiceType: 'ineligible',
            makerOrganizationUuid,
            currency,
            filters: filterKeys,
          });
        },
      }}
    />
  );
};

export default IneligibleInvoices;
